import { Component } from '@angular/core';

@Component({
    selector: 'app-auth-callback',
    template: '', // Intentionally empty — MSAL detects the token in the popup and closes it
    styles: [],
})
export class AuthCallbackComponent {}
